import { render } from "./JobBoardList.vue?vue&type=template&id=3c3ffb04&scoped=true&ts=true"
import script from "./JobBoardList.vue?vue&type=script&lang=ts"
export * from "./JobBoardList.vue?vue&type=script&lang=ts"

import "./JobBoardList.vue?vue&type=style&index=0&id=3c3ffb04&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3ffb04"]])

export default __exports__